import { arrayToCsv, downloadBlob } from '@utils/utils';

export type ExportToCSVOptions = {
  propertiesToStringify: string[];
  extractKeysFn: (a: any[], keysToStringify?: any[]) => string[];
  extractValuesFn: (a: any[], keysToStringify?: any[]) => string[];
};

const TYPENAME = '__typename';

const extractKeys = (obj, keysToStringify: string[] = []) =>
  Object.keys(obj).reduce((keys: string[], key) => {
    const value = obj[key];
    if (key === TYPENAME) {
      return keys;
    }
    if (keysToStringify.includes(key)) {
      return keys.concat(key);
    }
    if (Array.isArray(value)) {
      if (typeof value[0] !== 'object') {
        return keys.concat(key);
      }
      const objectKeys = Object.keys(value[0])
        .filter(subKey => subKey !== TYPENAME)
        .map(subKey => `${key} ${subKey}`);
      return keys.concat(objectKeys);
    }
    if (value && typeof value === 'object') {
      const objectKeys = extractKeys(value).map(subKey => `${key} ${subKey}`);
      return keys.concat(objectKeys);
    }
    return keys.concat(key);
  }, []);

const extractValues = (obj, keysToStringify: string[] = []) =>
  Object.keys(obj).reduce((values: string[], key) => {
    const value = obj[key];
    if (key === TYPENAME) {
      return values;
    }
    if (keysToStringify.includes(key)) {
      return values.concat(JSON.stringify(value));
    }
    if (Array.isArray(value)) {
      if (typeof value[0] !== 'object') {
        return values.concat(value.toString());
      }
      const objectValues = extractValues(value);
      return values.concat(objectValues);
    }
    if (value && typeof value === 'object') {
      const objectValues = extractValues(value);
      return values.concat(objectValues);
    }
    return values.concat(value);
  }, []);

export const exportToCSV = (data: any[], options: Partial<ExportToCSVOptions> = {}): void => {
  const defaults: ExportToCSVOptions = {
    propertiesToStringify: [],
    extractKeysFn: extractKeys,
    extractValuesFn: extractValues,
  };
  const { propertiesToStringify, extractKeysFn, extractValuesFn } = {
    ...defaults,
    ...options,
  };
  const headers = extractKeysFn(data[0], propertiesToStringify);
  const values = data.map(row => extractValuesFn(row, propertiesToStringify));
  const csv = arrayToCsv([headers, ...values]);
  return downloadBlob(csv, 'text/csv;charset=utf-8;', `export-${Date.now()}.csv`);
};
